// extracted by mini-css-extract-plugin
module.exports = {"container":"input-area_container__c359v"};